import { useTranslation } from 'react-i18next';
import { PaymentElement, AddressElement } from '@stripe/react-stripe-js';
import { Button } from 'react-daisyui';
import { isEmpty } from 'lodash';
import { useSubscriptionManagerContext } from 'src/pages/Settings/components/SubscriptionsManager/SubscriptionManager.context';
import { PAYMENT_ELEMENT_OPTIONS } from 'src/pages/Settings/components/SubscriptionsManager/SubscriptionManager.constants';
import CardSelector from 'src/pages/Settings/components/SubscriptionsManager/components/CardSelector/CardSelector.component';
import './TopUpModal.styles.scss';

/**
 * El bloque de método de pago del modal de recarga.
 *
 * Antes aquí había un botón que abría OTRO modal encima con el formulario de
 * Stripe. Se cambió por el mismo patrón que usa "Extiende el límite de
 * conversaciones activas": con tarjeta guardada se muestra cuál es, y sin ninguna
 * el formulario de Stripe se cobra aquí mismo, sin una pared de por medio.
 *
 * POR QUÉ VIVE EN EL WALLET Y LEE EL CONTEXTO DE AJUSTES. Los métodos de pago son
 * del manejador de suscripción, que es un provider de APLICACIÓN: `<Elements>` y
 * `<SubscriptionManagerProvider>` envuelven todo el árbol desde GRO-811 justo para
 * que esto sea alcanzable fuera de /settings. Consumirlo aquí evita propagar la
 * lista de tarjetas por props a través de tres pantallas distintas, que era la
 * alternativa y ya nos costó un bug de cableado a medias.
 *
 * NO deja ELEGIR con qué tarjeta cobrar, y la omisión es deliberada: el cobro del
 * wallet manda sólo monto y llave de idempotencia, así que la tarjeta la decide el
 * backend. Un selector que no cambiara el cobro sería una mentira cara — el cliente
 * elegiría una tarjeta y se le cobraría en otra. Se muestra la que se va a usar, y
 * cambiar la predeterminada sigue estando en Ajustes.
 */
export default function TopUpPaymentSection() {
  const { t } = useTranslation('wallet');
  const {
    selectedPaymentMethod,
    addPaymentMethod,
    addingPaymentMethod,
    toggleAddPaymentMethodModal,
  } = useSubscriptionManagerContext();

  const sinTarjeta = isEmpty(selectedPaymentMethod?.paymentMethodId);

  if (sinTarjeta) {
    return (
      <div
        className="TopUpModal__PaymentForm"
        data-testid="wallet-top-up-payment-form"
      >
        {/*
          El submit del form se ignora y el alta la dispara el botón: es el mismo
          trato que en el modal de Ajustes, y evita que un Enter en el campo de la
          tarjeta mande el formulario del modal de recarga que lo contiene.
        */}
        <form id="wallet-top-up-payment-form" onSubmit={(e) => e.preventDefault()}>
          <PaymentElement options={PAYMENT_ELEMENT_OPTIONS} />
          <AddressElement options={{ mode: 'billing' }} />
        </form>
        <Button
          color="primary"
          size="sm"
          className="mt-3"
          loading={addingPaymentMethod}
          onClick={() => addPaymentMethod()}
          data-testid="wallet-top-up-save-payment"
        >
          {t('topUp.payment.save')}
        </Button>
      </div>
    );
  }

  return (
    <div className="TopUpModal__PaymentPicked">
      {/*
        El selector queda INERTE a propósito (ver el docblock): muestra la tarjeta
        con la que se va a cobrar, con el mismo aspecto que en Ajustes, sin ofrecer
        un cambio que el cobro no respetaría.
      */}
      <div
        className="pointer-events-none"
        aria-disabled="true"
        data-testid="wallet-top-up-payment-picked"
      >
        <CardSelector />
      </div>
      <Button
        variant="link"
        size="sm"
        className="text-neutral-content w-fit px-0"
        onClick={() => toggleAddPaymentMethodModal(true)}
        data-testid="wallet-top-up-add-payment"
      >
        {t('topUp.payment.addAnother')}
      </Button>
    </div>
  );
}
